// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum AccountingDocumentsInventoryFileRejectionReason {
  DUPLICATE_DOCUMENT_FILE_EXISTS = "DUPLICATE_DOCUMENT_FILE_EXISTS",
  INCORRECT_DOCUMENT_FILE_FORMAT_FOUND = "INCORRECT_DOCUMENT_FILE_FORMAT_FOUND",
  INCORRECT_DOCUMENT_FILE_NAME_FOUND = "INCORRECT_DOCUMENT_FILE_NAME_FOUND",
  REQUIRED_COLUMNS_NOT_FOUND = "REQUIRED_COLUMNS_NOT_FOUND",
  INVALID_ACCOUNTING_PERIOD_FOUND = "INVALID_ACCOUNTING_PERIOD_FOUND",
  INVENTORY_ACCOUNT_NOT_FOUND = "INVENTORY_ACCOUNT_NOT_FOUND",
  DOCUMENT_FILE_FOR_INVENTORY_ACCOUNT_EXISTS = "DOCUMENT_FILE_FOR_INVENTORY_ACCOUNT_EXISTS",
  ROWS_WITH_OTHER_INVENTORY_ACCOUNT_FOUND = "ROWS_WITH_OTHER_INVENTORY_ACCOUNT_FOUND",
  INVALID_ROW_VALUES = "INVALID_ROW_VALUES",
}

export default AccountingDocumentsInventoryFileRejectionReason;
